import React from 'react';

// Components
import * as S from './Styled';
import GroupSwitch from '../GroupSwitch';
import { useTranslation } from 'react-i18next';

const Volume = ({ buttons }) => {
  let { t } = useTranslation();

  return (
    false && (
      <S.Line>
        <S.Capt>{t('labels.volume')}</S.Capt>
        <GroupSwitch
          buttons={[
            {
              id: 'vol-1',
              value: '50 шт.',
              name: 'volume',
            },
            {
              id: 'vol-2',
              value: '100 шт.',
              name: 'volume',
            },
            {
              id: 'vol-3',
              value: '200 шт.',
              name: 'volume',
            },
          ]}
        />
      </S.Line>
    )
  );
};

export default Volume;
